import { useState } from "react";
import { toast } from "sonner";

import SvgIcon from "components/base/SvgIcon";

const DownloadSelectedButton = ({ selectedHits, jobTitle }) => {
  const [downloading, setDownloading] = useState(false);
  const [progress, setProgress] = useState({ done: 0, total: 0 });

  const handleDownload = async () => {
    setDownloading(true);
    setProgress({ done: 0, total: selectedHits.length });

    try {
      // Lazy-load so pdf-lib/fflate stay out of the main bundle
      const { buildCandidateBundle, downloadZip, sanitizeFilename } =
        await import("utils/helpers/bulkDownload");

      const { files, failures, skipped } = await buildCandidateBundle(
        selectedHits,
        jobTitle,
        (done, total) => setProgress({ done, total })
      );

      if (Object.keys(files).length === 0) {
        toast.error(
          "Nothing to download — the selected candidates have no resumes or match analyses."
        );
        return;
      }

      downloadZip(files, sanitizeFilename(jobTitle, "candidates"));

      if (failures.length) {
        toast.warning(
          `Could not include ${failures.length} candidate(s): ${failures
            .map((failure) => failure.name)
            .join(", ")}`
        );
      }
      if (skipped.length) {
        toast.info(
          `Skipped ${skipped.length} candidate(s) with no resume or match analysis.`
        );
      }
    } catch (error) {
      console.error("Bulk download failed", error);
      toast.error("Download failed. Please try again.");
    } finally {
      setDownloading(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handleDownload}
      disabled={downloading}
      className="inline-flex items-center gap-2 rounded-md border border-gray-300 bg-white px-3 py-2 font-rubik text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-60"
    >
      <SvgIcon type="downloadFile" className="h-4 w-4 shrink-0" />
      {downloading
        ? `Preparing download... (${progress.done}/${progress.total})`
        : `Download (${selectedHits.length})`}
    </button>
  );
};

export default DownloadSelectedButton;
